import React from "react";
import { Link } from "react-router-dom";

/**
 * Renders a clickable GRN number that navigates to /grn?view=<number>.
 * Wave 10: GRN numbers across modules act as hyperlinks (replaces the eye-button-only flow).
 */
export default function GRNLink({ number, className = "", testId }) {
  if (!number) return <span className="text-[#0D2B5E]/40">—</span>;
  return (
    <Link
      to={`/grn?view=${encodeURIComponent(number)}`}
      data-testid={testId || `grn-link-${number}`}
      className={`font-mono text-[#1565C0] font-bold hover:underline hover:text-[#0D2B5E] transition ${className}`}
      title={`Open ${number}`}
    >
      {number}
    </Link>
  );
}
